import React from 'react'
import { Select, Input, InputNumber } from 'antd'
const { Option } = Select
export default props => {
  const {
    data,
    handleExtSave,
    // mode = 'V',
    // lock = 'U',
    // isAdmin = false,
    disableComp = false,
  } = props

  const {
    rxShutdown = '',
    rampCode = '',
    scUtilCode = '',
    inpoStatus = '',
    internalEventType = '',
    internalAvailCap = '',
    comments = '',
    outageNarrative = '',
  } = data

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gridGap: '30px',
      }}
    >
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '150px 300px',
          gridGap: '10px',
        }}
      >
        <div style={{ justifySelf: 'end', alignSelf: 'center' }}>
          RX Shutdown Method
        </div>
        <Select
          value={rxShutdown}
          onChange={value => handleExtSave('rxShutdown', value)}
          key="rxShutdown"
          disabled={disableComp}
        >
          <Option key="-1" value="" style={{ height: '20px' }} />
          <Option key="0" value="0">
            0-Reactor Critical
          </Option>
          <Option key="1" value="1">
            1-Manual
          </Option>
          <Option key="2" value="2">
            2-Manual Trip/Scram
          </Option>
          <Option key="3" value="3">
            3-Automatic Trip/Scarm
          </Option>
          <Option key="4" value="4">
            4-Continuation
          </Option>
          <Option key="5" value="5">
            5-Other
          </Option>
        </Select>
        <div style={{ justifySelf: 'end', alignSelf: 'center' }}>Ramp Code</div>
        <Select
          value={rampCode}
          onChange={value => handleExtSave('rampCode', value)}
          disabled={disableComp}
        >
          <Option key="-1" value="" style={{ height: '20px' }} />
          <Option key="2">2-Hold</Option>
          <Option key="4">4-Decrease</Option>
          <Option key="5">5-Dispatch</Option>
          <Option key="9">9-Increase</Option>
        </Select>
        <div style={{ justifySelf: 'end', alignSelf: 'center' }}>
          SC Util Code
        </div>
        <Select
          value={scUtilCode}
          onChange={value => handleExtSave('scUtilCode', value)}
          disabled={disableComp}
        >
          <Option key="-1" value="" style={{ height: '20px' }} />
          <Option key="1" value="1">
            1-Reas. Refuel Outage
          </Option>
          <Option key="2" value="2">
            2-Reas. Maint/Repair
          </Option>
          <Option key="3" value="3">
            3-Coastdown
          </Option>
          <Option key="4" value="4">
            4-Power Ascension
          </Option>
          <Option key="5" value="5">
            5-NRC Test/Outage/Reduction
          </Option>
          <Option key="6" value="6">
            6-SCPSC Identified OMC
          </Option>
          <Option key="7" value="7">
            7-Acts of God Reductions
          </Option>
          <Option key="8" value="8">
            8-Reas. Low System Load Reduction
          </Option>
        </Select>
        <div style={{ justifySelf: 'end', alignSelf: 'center' }}>
          Inpo Status
        </div>
        <Select
          value={inpoStatus}
          onChange={value => handleExtSave('inpoStatus', value)}
          disabled={disableComp}
        >
          <Option key="-1" value="" style={{ height: '20px' }} />
          <Option value="Plan">Plan</Option>
          <Option value="Plan Ext">Plan Ext</Option>
          <Option value="Forced">Forced</Option>
          <Option value="Forced Ext">Forced Ext</Option>
        </Select>
        <div style={{ justifySelf: 'end', alignSelf: 'center' }}>
          Internal Event Type
        </div>
        <Select
          value={internalEventType}
          onChange={value => handleExtSave('internalEventType', value)}
          disabled={disableComp}
        >
          <Option key="-1" value="" style={{ height: '20px' }} />
          <Option value="CC">CC</Option>
          <Option value="ED">ED</Option>
          <Option value={`${'Unplan loss< 10 days'}`}>
            {`${'Unplan loss< 10 days'}`}
          </Option>
        </Select>
        <div style={{ justifySelf: 'end', alignSelf: 'center' }}>
          Internal Avail. Cap
        </div>
        <InputNumber
          style={{ width: '100%' }}
          value={internalAvailCap}
          min={0}
          onChange={value => handleExtSave('internalAvailCap', value)}
          disabled={disableComp}
        />
      </div>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '350px',
          gridTemplateRows: '1fr 3fr 1fr 3fr',
        }}
      >
        <div style={{ alignSelf: 'end' }}>Remedial Action Taken</div>
        <Input.TextArea
          value={comments}
          onChange={e => handleExtSave('comments', e.target.value)}
          disabled={disableComp}
        />
        <div style={{ alignSelf: 'end' }}>Reason Outage Occured</div>
        <Input.TextArea
          value={outageNarrative}
          onChange={e => handleExtSave('outageNarrative', e.target.value)}
          disabled={disableComp}
        />
      </div>
    </div>
  )
}
